module.exports = __webpack_public_path__ + "img/electric-bike.06e6b354.svg";